import { equals } from '@execonline-inc/collections';
import { when } from '@execonline-inc/maybe-adapter';

export type TabName = 'programs' | 'schoolPartners' | 'competencies';
export interface State {
  tabName: TabName;
}

export const setTab = (tab: TabName): State => ({
  tabName: tab,
});

export const activeTabClassName = (state: State, tabName: TabName) =>
  when(equals(tabName), state.tabName)
    .map(() => 'active border-teal-600 text-teal-600')
    .getOrElseValue('border-transparent hover:border-gray-300 hover:text-gray-600');

export const activeSpanClassName = (state: State, tabName: TabName) =>
  when(equals(tabName), state.tabName)
    .map(() => 'bg-teal-600')
    .getOrElseValue('bg-gray-300');

export const activeTabPageClassName = (state: State, tabName: TabName) =>
  when(equals(tabName), state.tabName)
    .map(() => 'block')
    .getOrElseValue('hidden');
